// Main Firebase services index - exports all functions from modular files
import { httpsCallable } from "firebase/functions";
import { app, db, auth, storage, functionsInstance } from "./firebase-config";

// Export Firebase instances
export { app, db, auth, storage };

// Import and re-export all functions from modular files
export * from "./storage";
export * from "./submissions";
export { 
  getUserProfile,
  updateUserProfile,
  saveProfileLinks,
  saveVideoToUserProfile,
  createUserProfile,
  getAllUsers,
  uploadResume,
  getUserStatus
} from "./user-profile";
export * from "./waitlistUsers";
export * from "./video";
export * from "./jobs";
export * from "./contacts";
export * from "./companies";
export * from "./startup-opportunities";
export * from "./forum";
export * from "./admin";

// Email callable function
export const sendAppEmailCallable = httpsCallable(functionsInstance, 'sendAppEmail');

// Additional function aliases and missing implementations
export { addJobRecommendation as addRecommendedJobToUser } from "./jobs";